import { useNavigate } from "react-router-dom";
import { formatDate } from "./common/BaseUtil"
import './Notice.css'

export function NoticeTableRow(props) {
    let navigate = useNavigate();
    function onClick() {
        let objectId = props.object.id.toString()
        let url = "/notice?id=" + objectId;
        navigate(url);
    }

    return (
        <tr key={props.index}>
            <td onClick={onClick}>{props.object.noticeTitle}</td>
            <td className="responsive-notice">{formatDate(props.object.createAt)}</td>
            <td className="responsive-notice">{props.object.hitCount}</td>
        </tr>
    );
}